<template>
  <div class="grid-x error-404-cont">
    <div class="content-image">
      <img width="243" height="244" src="https://www.macys.com/img/error-pages/404/11Fx2011.35_404.gif" alt="" />
    </div>
    <div class="content">
      <p>
        We've searched high and low, but the web address you entered can''t be found or no longer exists. Please double check the address you entered
        and try again-or feel free to keep shopping throughout the rest of the site!
      </p>
      <div>
        <a title="back to homepage" href="/index.ognc">
          <img
            class="home_button"
            width="152"
            height="25"
            title="back to homepage"
            alt="back to homepage"
            src="https://www.macys.com/img/error-pages/404/11Fx2011.35_404_home_button.gif"
          />
        </a>
        <p>Questions? Visit <a href="/service/index.jsp">customer service</a> online to find answers and get help 24/7.</p>
        <p>Thanks for shopping with us!</p>
        <div>Looking for the latest deals at your local Macy's?</div>
        <div>
          <a href="http://macys.shoplocal.com/macys/default.aspx?action=entryflash&amp;">shop our weekly ad</a>
        </div>
        <div>
          <a href="/store/locator/index.ognc">find a store near you</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-404-cont {
  flex-wrap: nowrap;
  margin: 0 auto rem-calc(100px) auto;
  width: rem-calc(800px);
  background-color: #fff;
  background-color: #fff;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  .content-image {
    padding: rem-calc(35px) rem-calc(15px) rem-calc(100px) rem-calc(10px);
    img {
      width: rem-calc(243px);
      min-width: rem-calc(243px);
    }
  }
  .content {
    margin: rem-calc(41px) rem-calc(10px) rem-calc(30px) 0;
    .home_button {
      margin-bottom: rem-calc(5px);
    }
    p {
      margin-bottom: 1em;
    }
    p,
    a,
    div {
      font-size: 13px;
      line-height: 18px;
      font-family: Arial, Helvetica, sans-serif;
      color: #000;
    }
  }
}
</style>
